export const forumSections = [
  {
    id: "film",
    name: "影视交流",
    desc: "聊聊最近上映的电影、追的剧集，分享观后感与角色解读。",
    icon: "ri-film-line",
    threadCount: 1286,
    todayCount: 42,
  },
  {
    id: "music",
    name: "音乐现场",
    desc: "推荐好歌、讨论演唱会与音乐节，交流乐评与现场体验。",
    icon: "ri-music-2-line",
    threadCount: 964,
    todayCount: 31,
  },
  {
    id: "game",
    name: "游戏天地",
    desc: "攻略交流、开黑组队、新游讨论，一切与游戏相关的话题。",
    icon: "ri-gamepad-line",
    threadCount: 2145,
    todayCount: 88,
  },
  {
    id: "general",
    name: "综合讨论",
    desc: "闲聊灌水、热点吐槽、日常分享，与娱乐无关也没关系。",
    icon: "ri-chat-smile-2-line",
    threadCount: 1732,
    todayCount: 65,
  },
];

export const forumThreads = [
  {
    id: "thread-1",
    section: "film",
    title: "刚看完那部科幻大片，说说为什么我觉得它被低估了",
    author: "光影拾荒者",
    avatar:
      "https://readdy.ai/api/search-image?query=friendly%20young%20person%20portrait%20avatar%20with%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
    replies: 128,
    views: 5420,
    createdAt: "2026-10-14 09:20",
    lastReply: "3 分钟前",
    featured: true,
    content:
      "先说结论：这部片子的叙事节奏确实慢，但它慢得有理由。前半段所有的铺垫，都在为结尾那个反转服务。很多人吐槽人物动机不足，其实是没注意到几个非常隐蔽的细节镜头。我二刷之后才完全看懂，建议觉得闷的朋友耐心再看一遍。",
    replyList: [
      {
        id: "reply-1",
        user: "深夜放映厅",
        avatar:
          "https://readdy.ai/api/search-image?query=creative%20person%20portrait%20avatar%20with%20cool%20blue%20background%2C%20soft%20lighting%2C%20minimal%20modern%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
        content: "同意，尤其是中段那场雨里的对话，信息量其实特别大，第一次看完全没在意。",
        time: "2026-10-14 10:05",
      },
      {
        id: "reply-2",
        user: "爆米花不加盐",
        avatar:
          "https://readdy.ai/api/search-image?query=cheerful%20person%20portrait%20avatar%20with%20warm%20orange%20background%2C%20soft%20lighting%2C%20minimal%20style&width=120&height=120&seq=avatar-03&orientation=squarish",
        content: "我倒是觉得节奏确实拖了，不过视觉效果值回票价，大屏看还是很爽。",
        time: "2026-10-14 10:41",
      },
      {
        id: "reply-3",
        user: "光影拾荒者",
        avatar:
          "https://readdy.ai/api/search-image?query=friendly%20young%20person%20portrait%20avatar%20with%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
        content: "对，这两种感受其实不冲突，喜欢慢节奏叙事的人会觉得很享受。",
        time: "2026-10-14 11:12",
      },
    ],
  },
  {
    id: "thread-2",
    section: "music",
    title: "求推荐！适合深夜单曲循环的治愈系歌单",
    author: "耳机里的宇宙",
    avatar:
      "https://readdy.ai/api/search-image?query=calm%20person%20portrait%20avatar%20with%20soft%20pastel%20background%2C%20gentle%20lighting%2C%20minimal%20aesthetic&width=120&height=120&seq=avatar-04&orientation=squarish",
    replies: 96,
    views: 3187,
    createdAt: "2026-10-14 00:15",
    lastReply: "18 分钟前",
    featured: true,
    content:
      "最近工作压力有点大，晚上总是睡不着，想找一些安静温暖的歌来听。不要太吵的，最好是那种木吉他或者钢琴为主的类型，有推荐的歌单或者单曲都可以，先谢谢大家了。",
    replyList: [
      {
        id: "reply-4",
        user: "午后三点",
        avatar:
          "https://readdy.ai/api/search-image?query=relaxed%20person%20portrait%20avatar%20with%20warm%20beige%20background%2C%20soft%20natural%20light%2C%20minimal%20style&width=120&height=120&seq=avatar-05&orientation=squarish",
        content: "推荐《星河彼岸》作者的那张专辑，整张都很适合睡前听，木吉他成分很高。",
        time: "2026-10-14 00:52",
      },
      {
        id: "reply-5",
        user: "耳机里的宇宙",
        avatar:
          "https://readdy.ai/api/search-image?query=calm%20person%20portrait%20avatar%20with%20soft%20pastel%20background%2C%20gentle%20lighting%2C%20minimal%20aesthetic&width=120&height=120&seq=avatar-04&orientation=squarish",
        content: "收到，已经加进歌单了，等下去听听看！",
        time: "2026-10-14 01:20",
      },
    ],
  },
  {
    id: "thread-3",
    section: "game",
    title: "开放世界新游开局太迷茫？这份两小时上手路线送给你",
    author: "攻略搬运工",
    avatar:
      "https://readdy.ai/api/search-image?query=confident%20gamer%20portrait%20avatar%20with%20dark%20teal%20background%2C%20moody%20lighting%2C%20modern%20minimal%20style&width=120&height=120&seq=avatar-06&orientation=squarish",
    replies: 214,
    views: 12840,
    createdAt: "2026-10-13 20:40",
    lastReply: "5 分钟前",
    featured: false,
    content:
      "看到好多新玩家在问开局该干什么，干脆整理了一份两小时上手路线。核心思路就是先清出生点支线，再点亮传送点，最后集中强化一把蓝色武器。按这个走能少走很多弯路，细节我整理在楼里。",
    replyList: [
      {
        id: "reply-6",
        user: "手残党本党",
        avatar:
          "https://readdy.ai/api/search-image?query=casual%20person%20portrait%20avatar%20with%20light%20green%20background%2C%20soft%20lighting%2C%20friendly%20minimal%20style&width=120&height=120&seq=avatar-07&orientation=squarish",
        content: "太及时了，我昨天刚入坑，正不知道要点哪个技能，感谢楼主！",
        time: "2026-10-13 21:15",
      },
      {
        id: "reply-7",
        user: "夜猫子玩家",
        avatar:
          "https://readdy.ai/api/search-image?query=young%20person%20portrait%20avatar%20with%20dark%20purple%20background%2C%20moody%20lighting%2C%20minimal%20modern%20style&width=120&height=120&seq=avatar-08&orientation=squarish",
        content: "补充一点，传送点一定要早点点亮，后面跑图真的省事太多了。",
        time: "2026-10-13 22:03",
      },
    ],
  },
  {
    id: "thread-4",
    section: "film",
    title: "经典悬疑剧要翻拍了，大家是期待还是担心？",
    author: "推理爱好者",
    avatar:
      "https://readdy.ai/api/search-image?query=thoughtful%20person%20portrait%20avatar%20with%20deep%20red%20background%2C%20dramatic%20lighting%2C%20minimal%20style&width=120&height=120&seq=avatar-09&orientation=squarish",
    replies: 173,
    views: 7620,
    createdAt: "2026-10-13 14:22",
    lastReply: "1 小时前",
    featured: false,
    content:
      "消息一出来论坛就炸了。我个人是既期待又害怕，原作在我心里地位太高了，很怕翻拍毁童年。不过换个角度想，如果新团队能给年轻观众带来一部好剧，好像也不错？大家怎么看？",
    replyList: [
      {
        id: "reply-8",
        user: "录像带收藏家",
        avatar:
          "https://readdy.ai/api/search-image?query=nostalgic%20person%20portrait%20avatar%20with%20warm%20sepia%20background%2C%20vintage%20lighting%2C%20minimal%20style&width=120&height=120&seq=avatar-10&orientation=squarish",
        content: "我持保留态度，原作最厉害的地方就是留白和氛围，翻拍很容易拍成流水线。",
        time: "2026-10-13 15:00",
      },
      {
        id: "reply-9",
        user: "推理爱好者",
        avatar:
          "https://readdy.ai/api/search-image?query=thoughtful%20person%20portrait%20avatar%20with%20deep%20red%20background%2C%20dramatic%20lighting%2C%20minimal%20style&width=120&height=120&seq=avatar-09&orientation=squarish",
        content: "希望制作方真的能请到原主创当顾问吧，那样至少不会跑偏太远。",
        time: "2026-10-13 15:35",
      },
    ],
  },
  {
    id: "thread-5",
    section: "music",
    title: "去看了一场小型livehouse演出，突然理解了现场的意义",
    author: "票根收藏癖",
    avatar:
      "https://readdy.ai/api/search-image?query=artistic%20person%20portrait%20avatar%20with%20warm%20amber%20background%2C%20soft%20lighting%2C%20minimal%20creative%20style&width=120&height=120&seq=avatar-11&orientation=squarish",
    replies: 64,
    views: 2410,
    createdAt: "2026-10-12 23:10",
    lastReply: "2 小时前",
    featured: false,
    content:
      "之前一直觉得听现场不如在家听录音室版本清晰，这次去了一场小场馆的演出，完全改变了我的想法。那种几百人一起跟着唱的氛围，是耳机永远给不了的。强烈建议大家有机会都去体验一次。",
    replyList: [
      {
        id: "reply-10",
        user: "耳机里的宇宙",
        avatar:
          "https://readdy.ai/api/search-image?query=calm%20person%20portrait%20avatar%20with%20soft%20pastel%20background%2C%20gentle%20lighting%2C%20minimal%20aesthetic&width=120&height=120&seq=avatar-04&orientation=squarish",
        content: "对！小场馆的回声反而更好听，而且离歌手特别近，能看清每一个表情。",
        time: "2026-10-12 23:48",
      },
    ],
  },
  {
    id: "thread-6",
    section: "game",
    title: "这个Boss我打了整整一个下午，终于无伤过了，分享一下思路",
    author: "手残党本党",
    avatar:
      "https://readdy.ai/api/search-image?query=casual%20person%20portrait%20avatar%20with%20light%20green%20background%2C%20soft%20lighting%2C%20friendly%20minimal%20style&width=120&height=120&seq=avatar-07&orientation=squarish",
    replies: 88,
    views: 3960,
    createdAt: "2026-10-12 17:30",
    lastReply: "4 小时前",
    featured: false,
    content:
      "被卡了很久，后来发现关键就是别贪刀。它一套连招打完会有个明显的停顿，抓住那个窗口输出两下就撤。节奏找到了之后其实没那么难，祝还在卡关的朋友们早日通关。",
    replyList: [
      {
        id: "reply-11",
        user: "夜猫子玩家",
        avatar:
          "https://readdy.ai/api/search-image?query=young%20person%20portrait%20avatar%20with%20dark%20purple%20background%2C%20moody%20lighting%2C%20minimal%20modern%20style&width=120&height=120&seq=avatar-08&orientation=squarish",
        content: "受教了，我每次都是看到血条就想冲上去，结果被反打一套直接躺。",
        time: "2026-10-12 18:02",
      },
    ],
  },
  {
    id: "thread-7",
    section: "general",
    title: "你们周末一般都怎么放松？来交流一下解压方式",
    author: "周末好天气",
    avatar:
      "https://readdy.ai/api/search-image?query=cheerful%20person%20portrait%20avatar%20with%20sunny%20yellow%20background%2C%20bright%20lighting%2C%20friendly%20minimal%20style&width=120&height=120&seq=avatar-12&orientation=squarish",
    replies: 156,
    views: 6130,
    createdAt: "2026-10-12 11:05",
    lastReply: "30 分钟前",
    featured: false,
    content:
      "感觉最近大家都在忙，想听听各位周末是怎么放松的。我一般是睡到自然醒，然后煮杯咖啡看部老电影，晚上再打两把游戏，一套下来感觉又能充满电了。你们呢？",
    replyList: [
      {
        id: "reply-12",
        user: "深夜放映厅",
        avatar:
          "https://readdy.ai/api/search-image?query=creative%20person%20portrait%20avatar%20with%20cool%20blue%20background%2C%20soft%20lighting%2C%20minimal%20modern%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
        content: "我是去公园跑步，出一身汗再看两集剧，简单但很治愈。",
        time: "2026-10-12 12:40",
      },
    ],
  },
  {
    id: "thread-8",
    section: "film",
    title: "聊聊那些被低估的宝藏剧集，我先来抛砖引玉",
    author: "深夜放映厅",
    avatar:
      "https://readdy.ai/api/search-image?query=creative%20person%20portrait%20avatar%20with%20cool%20blue%20background%2C%20soft%20lighting%2C%20minimal%20modern%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
    replies: 112,
    views: 4870,
    createdAt: "2026-10-11 21:18",
    lastReply: "6 小时前",
    featured: false,
    content:
      "很多好剧因为宣发不足或者题材小众而被埋没，想开个帖子收集一下大家心里的宝藏剧集。我先说一部，讲城市夜班的纪实剧，节奏很慢但特别真实，看完之后对生活多了点耐心。",
    replyList: [
      {
        id: "reply-13",
        user: "票根收藏癖",
        avatar:
          "https://readdy.ai/api/search-image?query=artistic%20person%20portrait%20avatar%20with%20warm%20amber%20background%2C%20soft%20lighting%2C%20minimal%20creative%20style&width=120&height=120&seq=avatar-11&orientation=squarish",
        content: "推荐一部讲小城乐队的剧，音乐好听，故事也温暖，很适合周末慢慢看。",
        time: "2026-10-11 22:00",
      },
    ],
  },
  {
    id: "thread-9",
    section: "game",
    title: "组队开黑帖：晚上八点有没有一起上分的？",
    author: "夜猫子玩家",
    avatar:
      "https://readdy.ai/api/search-image?query=young%20person%20portrait%20avatar%20with%20dark%20purple%20background%2C%20moody%20lighting%2C%20minimal%20modern%20style&width=120&height=120&seq=avatar-08&orientation=squarish",
    replies: 47,
    views: 1520,
    createdAt: "2026-10-11 18:44",
    lastReply: "9 小时前",
    featured: false,
    content:
      "日常摸鱼队招人，晚上八点准时开黑，心态好不骂人，输赢随缘主要图个开心。段位不限制，会听话就行。有意向的直接回复楼层，我私聊拉群。",
    replyList: [
      {
        id: "reply-14",
        user: "手残党本党",
        avatar:
          "https://readdy.ai/api/search-image?query=casual%20person%20portrait%20avatar%20with%20light%20green%20background%2C%20soft%20lighting%2C%20friendly%20minimal%20style&width=120&height=120&seq=avatar-07&orientation=squarish",
        content: "算我一个！我最喜欢这种不压力的车队了。",
        time: "2026-10-11 19:10",
      },
    ],
  },
  {
    id: "thread-10",
    section: "general",
    title: "整理了一份本周娱乐资讯速览，没时间刷新闻的可以看这里",
    author: "资讯速览员",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20person%20portrait%20avatar%20with%20clean%20warm%20gray%20background%2C%20soft%20studio%20lighting%2C%20minimal%20modern%20style&width=120&height=120&seq=avatar-13&orientation=squarish",
    replies: 73,
    views: 5240,
    createdAt: "2026-10-11 08:30",
    lastReply: "12 小时前",
    featured: false,
    content:
      "本周的娱乐大事件都整理在这条帖子里了，包括新片上线、音乐盛典结果、还有几款新游戏的动态。每条都附上了简短说明，方便大家快速了解，也欢迎补充我漏掉的。",
    replyList: [
      {
        id: "reply-15",
        user: "周末好天气",
        avatar:
          "https://readdy.ai/api/search-image?query=cheerful%20person%20portrait%20avatar%20with%20sunny%20yellow%20background%2C%20bright%20lighting%2C%20friendly%20minimal%20style&width=120&height=120&seq=avatar-12&orientation=squarish",
        content: "太贴心了，这种汇总帖请务必每周都更新！",
        time: "2026-10-11 09:02",
      },
    ],
  },
];